import axios from '@/utils/axios';
import store from '@/utils/store';

const requestConfig = {
    timeout: Number(process.env.VUE_APP_API_TIMEOUT || 20000),
};

const handleError = async (error, router) => {
    console.error('Error:', error);

    const timelog_id = store.state.loggedUser?.timelog_id;

    // If string error
    if (typeof error === 'string' && error.toLowerCase().includes('unauthorized')) {
        await apiHelper.logout(router, timelog_id);
        router.push('/');
        return;
    }

    // If Axios error
    if (error.response) {
        const errorMsg = error.response.data?.error?.toLowerCase() || '';
        const errorName = error.response.data?.name;
        const isTokenExpired =
            errorMsg.includes('token expired') ||
            errorMsg.includes('jwt expired') ||
            errorName === 'TokenExpiredError';

        const isInvalidToken =
            errorMsg.includes('invalid token') ||
            errorName === 'JsonWebTokenError';

        if (isTokenExpired || isInvalidToken) {
            await apiHelper.logout(router, timelog_id);
            router.push('/');
            return;
        }
    }

    throw error;
};

const apiHelper = {
    async logout(router, id){
        try {
            const response = await axios.post('/logout', { data: id });
            if(response.data.success){
                store.commit('setIsLoggedIn', false);
                store.commit('setLoggedUser', null);
                store.commit('setToggleAsideMenu', true);
                store.commit('setJWTToken', null);
                store.commit('setToggleDarkMode', false);
                router.push('/');
            }
        } catch (error) {
            console.error('Error logging out:', error);
        }
    },
    async get(url, router) {
        try {
            const response = await axios.get(url, requestConfig);
            return response.data;
        } catch (error) {
            await handleError(error, router);
        }
    },
    async getInfoById(url, router) {
        try {
            const response = await axios.get(url, requestConfig);
            return response.data;
        } catch (error) {
            await handleError(error, router);
        }
    },
    async post(url, data, router) {
        try {
            const isFormData = data instanceof FormData;
            const response = await axios.post(url, isFormData ? data : { data }, {
                ...requestConfig,
                headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
            });
            return response.data;
        } catch (error) {
            await handleError(error, router);
        }
    },
    async put(url, data, router) {
        try {
            const response = await axios.put(url, { data : data }, requestConfig);
            return response.data;
        } catch (error) {
            await handleError(error, router);
        }
    },

    async delete(url, router) {
        try {
            const response = await axios.delete(url, requestConfig);
            return response.data;
        } catch (error) {
            await handleError(error, router);
        }
    },
};

export default apiHelper;
